<template>
    <div v-show="isOpen" v-bind="$attrs">
        <div class="content">
            <slot v-bind="this" />
        </div>
        <div class="mask" v-show="!disableMask" v-on:click="backdropClick()"></div>
    </div>
</template>

<script>
import { dialogComponent } from 'BASE/plugins/toastDialogPlugin';
export default {
    mixins: [dialogComponent],
    data() {
        return {
            defOptions: {
                title: '温馨提示',
                confirmStr: '确认',
                warningAutoHideLength: 5,
            },
        };
    },
    methods: {
        removeDialogClass() {
            document.body.classList.remove('v-dialog-show');
            document.body.style.paddingRight = '';
        },
    },
};
</script>
